import React, { useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { FaUserFriends, FaUserPlus } from 'react-icons/fa';
import { fetchConnections } from '../../redux/actions/connections';
import MiniLoader from '../Layout/MiniLoader';

const formatConnectionCount = (count = 0) => {
  return new Intl.NumberFormat('en', {
    notation: 'compact',
    maximumFractionDigits: count < 10000 ? 1 : 0,
  }).format(count);
};

const FollowersDisplay = React.memo(({ userId, profileType }) => {
  const maxDisplay = 3;
  const emptyDisplay = 1;
  const dispatch = useDispatch();

  const { followers, isLoadingFollowers, error } = useSelector(state => state.connections);

  // Fetch followers whenever userId or profileType changes
  useEffect(() => {
    if (userId && profileType) {
      dispatch(fetchConnections(userId, profileType, 'followers'));
    }
  }, [userId, profileType, dispatch]);

  // Memoize the followers display to prevent unnecessary re-renders
  const displayedFollowers = useMemo(() => {
    return followers ? followers.slice(0, maxDisplay) : [];
  }, [followers]);

  return (
    <div className="followers-avatar-display-container">
      {isLoadingFollowers && (
        <div className="mini-loader-container">
          <MiniLoader />
        </div>
      )}
      {error && <div>Error: {error}</div>}
      {!isLoadingFollowers && (
        <>
          <div className={`followers-avatar-display-images followers-avatar-display-images--count-${displayedFollowers.length || 0}`}>
            {displayedFollowers.length > 0 ? (
              displayedFollowers.map((follower, index) => (
                follower && follower._id ? (
                  <img
                    key={index}
                    className="followers-avatar-display-image"
                    src={follower.avatar}
                    alt={follower.name}
                  />
                ) : (
                  <div key={index} className="follower-placeholder">No Data</div>
                )
              ))
            ) : (
              <>
                {[...Array(emptyDisplay)].map((_, index) => (
                  <div key={index} className="followers-avatar-display-image empty-avatar">
                    <FaUserPlus className="followers-avatar-display-empty-icon" aria-hidden="true" />
                  </div>
                ))}
              </>
            )}
          </div>
          <div className="followers-avatar-display-count">
            <FaUserFriends className="followers-avatar-display-count-icon" aria-hidden="true" />
            <span>{formatConnectionCount(followers?.length || 0)} Followers</span>
          </div>
        </>
      )}
    </div>
  );
});

export default FollowersDisplay;








